import React from 'react';
import style from './examplesPresenter.scss';
import { ExampleTitle } from './ExampleTitle';
import { CodeBox } from './CodeBox';
import { EXAMPLE_TYPES } from '../../../types';

interface ExamplesPresenterProps {
  example: any;
  displayName: string;
  renderFor: EXAMPLE_TYPES;
}

export const ExamplesPresenter = ({
  example,
  displayName,
  renderFor,
}: ExamplesPresenterProps) => {
  const isRequestExample = renderFor === EXAMPLE_TYPES.REQUEST;

  return (
    <div
      className={`${style.codeExample} ${
        isRequestExample && style.requestCodeExample
      }`}
    >
      <span className="notranslate">
        <ExampleTitle
          example={example}
          displayName={displayName}
          renderFor={renderFor}
        />
        <CodeBox renderFor={renderFor} example={example} />
      </span>
    </div>
  );
};
